export const PRE_ENTRY_TIME_min = 15;
export const WAIT_INTERVIEWER_TIME_min = 5;
